module.exports = __webpack_public_path__ + "img/kaitz_no.bcd994be.png";